import { z } from "zod";

/**
 * Cap for user-editable entity names (device, zone, irrigation set, ...).
 * Organization names keep their own, shorter cap.
 */
export const ENTITY_NAME_MAX_LENGTH = 128;

/** Shared by the DTO and Mongoose validators on user-editable name fields. */
export const entityNameZodValidator = z.string().trim().min(1).max(ENTITY_NAME_MAX_LENGTH);

/**
 * Names that are still allowed to be stored empty.
 *
 * @deprecated Migrate remaining fields to {@link entityNameZodValidator}; an empty name has no
 * meaning to a user and only exists because these fields never rejected one.
 */
export const emptyableEntityNameZodValidator = z.string().trim().max(ENTITY_NAME_MAX_LENGTH).optional();
